import React from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import GirlIcon from '@mui/icons-material/Girl';
import WomanIcon from '@mui/icons-material/Woman';
import BoyIcon from '@mui/icons-material/Boy';
import ManIcon from '@mui/icons-material/Man';
import { useNavigate } from 'react-router';
import { useFetchTeamsQuery } from '../../store/team/TeamApi';
import { myConstants } from '../../shares/Constants';

const TEAM_TYPES = [
  { label: 'wU8 anmelden',  icon: <GirlIcon />,   is_female: true,  is_u8: true,  name: 'wu8'  },
  { label: 'wU10 anmelden', icon: <WomanIcon />,  is_female: true,  is_u8: false, name: 'wu10' },
  { label: 'mU8 anmelden',  icon: <BoyIcon />,    is_female: false, is_u8: true,  name: 'mu8'  },
  { label: 'mU10 anmelden', icon: <ManIcon />,    is_female: false, is_u8: false, name: 'mu10' },
];

export default function TeamFab({ year, clubLabel }) {
  const navigate = useNavigate();
  const { data: teams } = useFetchTeamsQuery({ year, clubLabel });

  const nextCounter = (is_female, is_u8) => {
    if (!teams) return 1;
    return teams.filter(t => t.is_female === is_female && t.is_u8 === is_u8).length + 1;
  };

  const handleClick = (type) => {
    const counter = nextCounter(type.is_female, type.is_u8);
    navigate(`/${year}/${clubLabel}/${type.name}/${counter}/${myConstants.endpoints.actions.team.add}`);
  };

  return (
    <SpeedDial
      ariaLabel="Team anmelden"
      sx={{ position: 'fixed', bottom: 48, right: 24 }}
      icon={<SpeedDialIcon />}
    >
      {TEAM_TYPES.map((type) => (
        <SpeedDialAction
          key={type.name}
          icon={type.icon}
          slotProps={{
            tooltip: {
              open : true,
              title: type.label,
            },
          }}
          sx={{whiteSpace: 'nowrap'}}
          FabProps={{ size: 'small'}}
          onClick={() => handleClick(type)}
        />
      ))}
    </SpeedDial>
  );
}